// Homepage Content Data - Grupo BMP Platform

export const heroContent = {
  preheadline: "Since 2008 | Global Operations | Premium Business Solutions",
  headline: "Global Trading Solutions, Arquitetura Empresarial, Operações & Gestão Internacional de Projetos, Petróleo & Gás",
  subheadline: "We structure, implement, and scale premium business operations across Dubai, Angola, and global markets.",
  trustIndicator: "Trusted by 50+ international companies"
};

export const aboutContent = {
  label: "About Grupo BMP",
  heading: "Building Excellence in Business Operations Since 2008",
  paragraphs: [
    "Grupo BMP is a premium business operations group specializing in consultancy, project management, and international implementation. With headquarters in Dubai and operations across Angola, we deliver sophisticated business solutions to companies seeking excellence in their operations.",
    "Our multidisciplinary approach combines strategic consulting, hands-on project delivery, and digital transformation to create lasting value for our clients across multiple industries and geographies."
  ],
  stats: [
    { number: "17+", label: "Years Experience" },
    { number: "3", label: "Continents" },
    { number: "50+", label: "Projects Delivered" }
  ]
};

export const servicesContent = {
  label: "Our Services",
  heading: "Comprehensive Business Solutions",
  subheading: "From strategy to execution, we deliver measurable results across all business functions.",
  services: [
    {
      id: 1,
      icon: "Target",
      title: "Consultancy & Strategy",
      description: "Strategic business planning, market analysis, and growth consulting for companies entering new markets or optimizing existing operations.",
      link: "/services/consultancy"
    },
    {
      id: 2,
      icon: "CheckSquare",
      title: "Project Management",
      description: "End-to-end project delivery using proven methodologies. From planning to implementation, we ensure your projects succeed on time and budget.",
      link: "/services/project-management"
    },
    {
      id: 3,
      icon: "Settings",
      title: "Operations & Implementation",
      description: "Operational excellence programs, process optimization, and hands-on implementation support to transform business operations.",
      link: "/services/operations"
    },
    {
      id: 4,
      icon: "Monitor",
      title: "Digital Platforms",
      description: "Custom CRM, ERP, and digital transformation solutions tailored to your business needs and integrated with existing systems.",
      link: "/services/digital-platforms"
    },
    {
      id: 5,
      icon: "Globe",
      title: "Global Trading Solutions",
      description: "Comprehensive commodity trading services including procurement, logistics coordination, and international trade facilitation across multiple markets.",
      link: "/services/global-trading"
    },
    {
      id: 6,
      icon: "Package",
      title: "Global Procurement",
      description: "Strategic sourcing and procurement solutions for international supply chain optimization, vendor management, and cost reduction initiatives.",
      link: "/services/global-procurement"
    }
  ]
};

export const projectsContent = {
  label: "Our Work",
  heading: "Featured Projects & Success Stories",
  projects: [
    {
      id: 1,
      title: "International Expansion Strategy",
      location: "Dubai, UAE",
      type: "Consultancy",
      description: "Comprehensive market entry strategy and implementation roadmap for European company entering MENA markets.",
      image: "project-1.jpg",
      link: "/projects/international-expansion"
    },
    {
      id: 2,
      title: "ERP System Implementation",
      location: "Luanda, Angola",
      type: "Digital Platform",
      description: "Full ERP deployment integrating finance, operations, and supply chain for multinational organization.",
      image: "project-2.jpg",
      link: "/projects/erp-implementation"
    },
    {
      id: 3,
      title: "Operational Restructuring",
      location: "Lisbon, Portugal",
      type: "Operations",
      description: "Complete operational overhaul resulting in 40% efficiency improvement and cost optimization.",
      image: "project-3.jpg",
      link: "/projects/operational-restructuring"
    },
    {
      id: 4,
      title: "Multi-Market Business Setup",
      location: "Dubai & Angola",
      type: "Project Management",
      description: "End-to-end business establishment across two markets including legal, operations, and team recruitment.",
      image: "project-4.jpg",
      link: "/projects/multi-market-setup"
    },
    {
      id: 5,
      title: "Global Commodity Trading Platform",
      location: "Dubai, UAE",
      type: "Global Trading",
      description: "Implementation of end-to-end commodity trading operations for oil, gas, and precious metals across MENA and African markets.",
      image: "project-5.jpg",
      link: "/projects/commodity-trading-platform"
    },
    {
      id: 6,
      title: "Strategic Procurement Optimization",
      location: "International",
      type: "Global Procurement",
      description: "Complete supply chain transformation and procurement strategy for multinational organization, reducing costs by 30%.",
      image: "project-6.jpg",
      link: "/projects/procurement-optimization"
    }
  ]
};

export const statsContent = {
  stats: [
    { number: "17+", label: "Years in Business" },
    { number: "50+", label: "Projects Delivered" },
    { number: "3", label: "Continents" },
    { number: "95%", label: "Client Retention Rate" }
  ]
};

export const clientsContent = {
  heading: "Trusted by Leading Organizations",
  subheading: "We're proud to work with companies who share our commitment to excellence."
};

export const insightsContent = {
  label: "Insights & Updates",
  heading: "Latest from Grupo BMP",
  articles: [
    {
      id: 1,
      category: "Strategy",
      title: "Navigating International Business Expansion in 2025",
      excerpt: "Key strategies and considerations for companies looking to expand their operations into new international markets.",
      image: "article-1.jpg",
      date: "Jan 15, 2025",
      link: "/insights/international-expansion-2025"
    },
    {
      id: 2,
      category: "Trading",
      title: "Global Commodity Trading: Trends and Opportunities",
      excerpt: "An in-depth analysis of emerging trends in commodity trading markets and how businesses can capitalize on new opportunities.",
      image: "article-2.jpg",
      date: "Jan 12, 2025",
      link: "/insights/commodity-trading-trends"
    },
    {
      id: 3,
      category: "Procurement",
      title: "Strategic Procurement in Multi-Market Environments",
      excerpt: "Best practices for optimizing procurement operations across different geographical markets and supplier networks.",
      image: "article-3.jpg",
      date: "Jan 8, 2025",
      link: "/insights/strategic-procurement"
    }
  ]
};

export const ctaContent = {
  heading: "Ready to Elevate Your Business Operations?",
  subheading: "Let's discuss how Grupo BMP can help you achieve your strategic objectives.",
  trustNote: "Join 50+ companies who trust Grupo BMP"
};

export const contactInfo = {
  email: "grupo.bmp@grupobmp.com",
  phone: "+971 XXX XXXX",
  locations: [
    { name: "Dubai, UAE", address: "Shams Business Center, Sharjah" },
    { name: "Luanda, Angola", address: "Kilamba, Block W, Building 15" },
    { name: "Lisbon, Portugal", address: "Business Center, Central District" }
  ]
};

export const navigationLinks = [
  { name: "About", path: "/about", i18nKey: "homepage.nav.about" },
  { name: "Services", path: "/services", i18nKey: "homepage.nav.services" },
  { name: "Projects", path: "/projects", i18nKey: "homepage.nav.projects" },
  { name: "Insights", path: "/insights", i18nKey: "homepage.nav.insights" },
  { name: "Contact", path: "/contact", i18nKey: "homepage.nav.contact" }
];

export const footerLinks = {
  company: [
    { name: "About Us", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Projects", path: "/projects" },
    { name: "Insights", path: "/insights" },
    { name: "Contact", path: "/contact" }
  ],
  services: [
    { name: "Consultancy & Strategy", path: "/services/consultancy" },
    { name: "Project Management", path: "/services/project-management" },
    { name: "Operations & Implementation", path: "/services/operations" },
    { name: "Digital Platforms", path: "/services/digital-platforms" },
    { name: "Training & Development", path: "/services/training" }
  ]
};
